/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Updated_LabelInputs */

const en_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated:`)
};

const fr_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis à jour :`)
};

const de_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiert:`)
};

const it_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornato:`)
};

const ru_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлено:`)
};

const es_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizado:`)
};

const zh_cn2_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新：`)
};

const ja_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日:`)
};

const hi_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट किया गया:`)
};

const pt_pt2_knp_guide_updated_label = /** @type {(inputs: Knp_Guide_Updated_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizado:`)
};

/**
* | output |
* | --- |
* | "Updated:" |
*
* @param {Knp_Guide_Updated_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_updated_label = /** @type {((inputs?: Knp_Guide_Updated_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Updated_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_updated_label(inputs)
	if (locale === "de") return de_knp_guide_updated_label(inputs)
	if (locale === "it") return it_knp_guide_updated_label(inputs)
	if (locale === "ru") return ru_knp_guide_updated_label(inputs)
	if (locale === "es") return es_knp_guide_updated_label(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_updated_label(inputs)
	if (locale === "ja") return ja_knp_guide_updated_label(inputs)
	if (locale === "hi") return hi_knp_guide_updated_label(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_updated_label(inputs)
	return en_knp_guide_updated_label(inputs)
});